// test2556
(2556 && 0);
